import { CredentialManager as CM } from "./credentialManager";
import { io, Socket } from "socket.io-client";
import { BackgroundRunner } from "@capacitor/background-runner"
import { socketURI } from '../config.json'
import { Chapter, User } from "chaptercoreapi";

export const CredentialManager = new CM()
export var globalUser: User | undefined = undefined
export var globalUsers: User[] = []
export var globalChapter: Chapter | undefined = undefined
// Importing required modules: Creds for credentials management and socket.io-client for WebSocket communication

// var socketInstance = io("https://backend.chaptercore.org/");
// Commented out production backend URL. Currently using localhost for development purposes.

console.log("Initializing socket");

var socketInstance: Socket = io(socketURI);
// Initializing socket connection with local server on port 3000 for development purposes.

console.log("Connecting to socket");
socketInstance.connect();
// Initiating connection to the WebSocket server.

socketInstance.on("connect", () => {

  console.log('%c Socket Successfully Connected ', 'background: #222; color: #bada55');
});
socketInstance.on("disconnect", () => {

  console.log('%c Socket disconnected ', 'background: #222; color: #e2071c');
});
export const socket = {
  socket: socketInstance,
  on: socketInstance.on.bind(socketInstance),
  id: socketInstance.id,
  emit: (ev: string, body: Object, callback: Function = () => { }) => {
    let data = CredentialManager.getData();
    // Fetching user data using CredentialManager.

    const payload = {
      body: body,
      id: socketInstance.id,
      DeviceId: CredentialManager.getStorage().
        getItem("_capuid"),
      userData: data == undefined ? {} : data,
      // Creating payload to be sent, including user data if available.
    };

    socketInstance.emit(ev, JSON.stringify(payload), (response: any) => callback && callback(response));
    // Emitting event to server with serialized payload. If callback is provided, it's executed with the server response.
  },
  join: (roomId: string) => {
    socket.emit("join room", {
      Id: roomId,
      // Joining a specific room by room ID.
    });
  },
};
socket.socket.on("SESSION TOKEN", (data: { SessionToken: string, error?: string }) => {
  if (data.error) return
  CredentialManager.SaveData(data.SessionToken);
})
// Adding an event listener for any event that occurs on the socket instance and logging the event and its arguments.
socket.socket.onAny((event, ...args) => {
  console.log(event, args);
});
setInterval(() => {
  if (!CredentialManager.hasData()) {globalChapter=undefined; globalUser=undefined;globalUsers=[];return}
  socket.emit("get user info", {}, (data: { message: string, user: User }) => {
    if (data.message == "Success")
      globalUser = User.buildUserFromJsonWithRole(data.user)
  })
  socket.emit("get users", {}, (data: Object) => {
    for (let user in data) {
      globalUsers.push(User.buildUserFromJsonWithRole(user))
    }
  })

  socket.emit("get chapter", {}, (data: { message: string, chapter: object }) => {
    console.log(data)

    if (data.message == "Success")
      console.log("dataIn", data)
      globalChapter = Chapter.buildChapterFromJsonWithRoles(data.chapter)
    console.log("dataOut",globalChapter)
  })
}, 1000);
/**
 * Play notification sound when required.
 * This will be used in the desktop app; mobile implementation may differ.
 */
export function playSound() {
  let mySound = new Audio("https://firebasestorage.googleapis.com/v0/b/twetzel-a07f2.appspot.com/o/sounds%2Fmixkit-gaming-lock-2848_A_major__bpm_121_B%E2%99%AD_major__bpm_102.mp3?alt=media&token=d22be255-dbd0-455c-83b9-4ea6a06569d2");
  mySound.play();
  // Play audio from a given URL. Useful for notifying users of certain events.
}

/**
 * Send a desktop notification.
 * @param {string} title - The title of the notification.
 * @param {string} body - The body text of the notification.
 * @param {string} icon - The icon to use for the notification (default is a logo path).
 * @param {object} options - Additional options for the notification (optional).
 */
export function sendNotification(title: string, body: string, icon: string = "../dist/img/logo.png", options = undefined) {
  if (Notification.permission !== "granted") Notification.requestPermission();
  // Request permission if notifications are not already granted.
  else {
    var notification = new Notification(title, {
      icon: icon,
      body: body,
    });
    // Create a new notification with the specified title, icon, and body text.

    notification.onclick = function () {
      if (eval("window['desktop']==true")) {
        window.open(`chaptercore://`);
        // Open custom URL scheme if running on a desktop app (uses eval - be cautious).
      } else window.open(``);
      // If not on desktop, open a blank URL (could be adjusted for different behavior).
    };
  }
}
// Function to send desktop notifications, checking first if permissions are granted. This is used to alert users about important events or updates.
